import {
    AfterViewInit,
    Component,
    ComponentFactoryResolver,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {NoosFormTypeService} from '../../../../class/NoosFormTypeService';
import {FormItemComponentInterface} from '../../../../interface/component';
import {IActivity, IActivityItem, IFormItemsControls} from '../../../../interface/form-structure';
import {IFieldShema} from '@usteknoloji/noosgrid';
import {GlobalObjectService} from '../../../../class/global-obj';
import * as _ from 'lodash';
import {HttpFormDataService} from '../../../../services/services';
import {IHttpSetting} from '../../../../interface/dataset-params';

@Component({
    selector: 'noos-view-activity',
    templateUrl: './view-activity.component.html',
    styleUrls: ['./view-activity.component.scss']
})

@NoosFormTypeService.register('viewActivity')
export class ViewActivityComponent implements OnInit, AfterViewInit, FormItemComponentInterface {


    prop: IFormItemsControls;
    isFilter = false;


    @Output()
    keyOnEnter: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    datasetId = 0;

    @Input()
    formId = 0;

    recordId = 0;

    formFieldStructure: IFieldShema[];
    formRecordData: any;
    pkeys: any;

    setting: IHttpSetting;

    activities: IActivity[] = [];

    constructor(private httpService: HttpFormDataService,
                private componentFactoryResolver: ComponentFactoryResolver, private noosFormTypeFactory: NoosFormTypeService, ) {

        this.setting = GlobalObjectService.getVar('setting');

    }

    ngOnInit(): void {

        this.formFieldStructure = _.orderBy(GlobalObjectService.getVar('formFieldStructure_' + this.formId.toString()), ['list_order'], ['ASC']);
        this.formRecordData = GlobalObjectService.getVar('formRecordData_' + this.formId.toString());
        this.pkeys = GlobalObjectService.getVar('pkeys_' + this.formId.toString());
    }

    ngAfterViewInit(): void {
        if (this.prop.viewOptions !== undefined) {
            this.recordId = parseInt(GlobalObjectService.getVar('record_id_' + this.formId.toString()), 0);
            this.loadActivity();
        }
    }

    loadActivity() {
        this.httpService.getActivityforDataset(this.setting, this.prop.viewOptions.source_dataset_id, this.recordId).subscribe(ret => {
            if (ret.complete) {
                this.activities = ret.data;
            }
        });
    }

    getSortedItems(items: IActivityItem[]){
        return items.sort(((a, b) => a.timex_hour > b.timex_hour ? -1 : 1));
    }

}
